import { findAll, find, register, throttle } from '../../../Javascript/Utils'

const component = (el) => {
  const componentPrefix = el.dataset.componentprefix
  const submenus = findAll(`.${componentPrefix}mainNav .${componentPrefix}submenuWrap`, el)
  const mainNav = find(`.${componentPrefix}mainNav`, el)
  const menuAnchors = findAll(`.${componentPrefix}anchor`, el)

  // eslint-disable-next-line no-undef
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          entry.target.classList.add('submenu--left')
        }
      })
    },
    {
      threshold: 1
    }
  )

  submenus.forEach((submenu) => {
    observer.observe(submenu)
  })

  menuAnchors.forEach(element => {
    element.addEventListener('click', function (e) {
      mainNav.classList.add('jump-to-anchor')
      setTimeout(() => mainNav.classList.remove('jump-to-anchor'), 500)
    })
  })

  // Hide/show meta navigation when scrolling down/up.
  let lastScrollDistance = 0
  let scrolledDistance = 0
  document.addEventListener('scroll', throttle(function (event) {
    const scrollDistance = document.documentElement.scrollTop
    const bodyElement = document.getElementsByTagName('body')[0]
    const navContainerElement = document.getElementsByClassName(`${componentPrefix}navigation-container`)[0]

    if (scrollDistance < lastScrollDistance) {
      scrolledDistance += lastScrollDistance - scrollDistance
    }

    if (scrollDistance > lastScrollDistance && scrollDistance > 105) {
      if (!bodyElement.classList.contains('down')) {
        bodyElement.classList.add('down')
        // 100 seems to be the height of the main navigation.
        navContainerElement.style.transform = `translate3d(0, -${navContainerElement.offsetHeight - 100}px, 0)`
      }

      scrolledDistance = 0
    } else if (scrolledDistance > 100) {
      if (bodyElement.classList.contains('down')) {
        bodyElement.classList.remove('down')
        navContainerElement.style.transform = null
      }

      scrolledDistance = 0
    }

    lastScrollDistance = scrollDistance
  }, 100))
}

register('header', component)
